import * as React from "react";
function SvgIcAuthMenu(props) {
  return <svg width="1em" height="1em" viewBox="0 0 14 14" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}><g stroke="currentColor" strokeLinecap="round" strokeLinejoin="round"><path d="M11 2H1M11 6H1M5 10.5H1M13 8l-4 4-2-3" /></g></svg>;
}
export default SvgIcAuthMenu;